/**
 *
 * Asynchronously loads the CustomizeableColumnsDrawer component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
